import React from 'react';
import { Section, SectionHeader } from './ui/Section';
import { Card } from './ui/Card';
import { Reveal } from './ui/Reveal';
import { Shield, Target, Users, Award } from 'lucide-react';
export function ArmyLeadershipSection() {
  return <Section id="army-leadership" variant="navy" data-id="element-16">
      <SectionHeader title="Army Command" subtitle="Combatant Command Leadership" data-id="element-17" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-18">
        <Reveal data-id="element-19">
          <Card className="h-full border-t-4 border-t-gold-500" data-id="element-20">
            <Shield className="w-10 h-10 text-gold-500 mb-6" data-id="element-21" />
            <h3 className="text-xl font-bold text-white uppercase mb-2" data-id="element-22">
              Deputy G-4
            </h3>
            <p className="text-sm text-gold-500 font-heading tracking-wider mb-4" data-id="element-23">
              U.S. Army Forces Command
            </p>
            <p className="text-slate-400 text-sm leading-relaxed" data-id="element-24">
              Oversight of logistics readiness for 450,000 Soldiers. Managed
              equipment availability and sustainment strategies for the Army's
              largest command.
            </p>
          </Card>
        </Reveal>

        <Reveal delay={200} data-id="element-25">
          <Card className="h-full border-t-4 border-t-gold-500" data-id="element-26">
            <Target className="w-10 h-10 text-gold-500 mb-6" data-id="element-27" />
            <h3 className="text-xl font-bold text-white uppercase mb-2" data-id="element-28">
              Assistant Deputy Chief of Staff
            </h3>
            <p className="text-sm text-gold-500 font-heading tracking-wider mb-4" data-id="element-29">
              Logistics (Afghanistan)
            </p>
            <p className="text-slate-400 text-sm leading-relaxed" data-id="element-30">
              Directed in-theater logistics operations during combat operations.
              Managed complex supply lines in contested environments.
            </p>
          </Card>
        </Reveal>

        <Reveal delay={400} data-id="element-31">
          <Card className="h-full border-t-4 border-t-gold-500" data-id="element-32">
            <Award className="w-10 h-10 text-gold-500 mb-6" data-id="element-33" />
            <h3 className="text-xl font-bold text-white uppercase mb-2" data-id="element-34">
              Director
            </h3>
            <p className="text-sm text-gold-500 font-heading tracking-wider mb-4" data-id="element-35">
              CSA Coordination Group
            </p>
            <p className="text-slate-400 text-sm leading-relaxed" data-id="element-36">
              Strategic coordination for the Chief of Staff of the Army.
              Facilitated high-level decision-making and policy implementation.
            </p>
          </Card>
        </Reveal>
      </div>

      <Reveal delay={600} data-id="element-37">
        <div className="bg-navy-800 border border-white/5 p-8 rounded-sm flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-38">
          <div className="flex items-center gap-4" data-id="element-39">
            <Users className="w-12 h-12 text-gold-500" data-id="element-40" />
            <div data-id="element-41">
              <h4 className="text-2xl font-bold text-white" data-id="element-42">450,000+</h4>
              <p className="text-slate-400 text-sm uppercase tracking-wider" data-id="element-43">
                Soldiers Supported
              </p>
            </div>
          </div>
          <div className="h-px w-full md:w-px md:h-16 bg-white/10" data-id="element-44"></div>
          <div className="flex items-center gap-4" data-id="element-45">
            <Shield className="w-12 h-12 text-gold-500" data-id="element-46" />
            <div data-id="element-47">
              <h4 className="text-2xl font-bold text-white" data-id="element-48">$18B</h4>
              <p className="text-slate-400 text-sm uppercase tracking-wider" data-id="element-49">
                Tactical Vehicle Budget
              </p>
            </div>
          </div>
        </div>
      </Reveal>
    </Section>;
}